<template>
    <div>
        <div class="rules__header rules__header-staff">
            <div class="text-size-18 text-bold rules__header-wrapper">
                <div class="rules__header-left">
                    <span class="ts-name --staff">
                        <span>Контакты</span>
                        <div class="count">{{ userTotal }}</div>
                    </span>
                </div>
                <div class="rules__header-right"
                     v-if="usersGroupedCurrentIndex != 'dismiss' && (userCurrent.access_rights.is_owner || userCurrent.is_can_contact_edit)">
                    <span class="ss-name --staff">
                    {{ contactsGroupedCurrent.name }}
                    </span>
                    <div class="df">
                        <div class="rules__btn" @click="openAddContact([])">
                        <span class="elem">
                            <span class="i i-staff4"></span>
                            Добавить контакт
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="container staff-container">
                <aside-sticky :marginTop="88" :marginBottom="0">
                    <aside class="aside aside--left aside--catalog" ref="aside">
                        <div class="aside__sticky" id="aside-sticky">
                            <div class="nav nav--city">
                                <div class="nav-wrapper" v-if="contactGrouped.length">
                                    <draggable :forceFallback="true"
                                               :disabled="(!canDrag || popups.addRule.show) && !(userCurrent.access_rights.is_owner || userCurrent.is_can_contact_edit)"
                                               element="ul"
                                               v-model="contactGrouped"
                                               :move="dragStatus"
                                               @end="dragSaveGrouped"
                                               :animation="150"
                                               :touchStartThreshold="3"
                                               :delay="10"
                                               class="nav-list">
                                        <li class="nav-list-item" v-for="(department, index) in contactGrouped"
                                            :key="department.id">
                                            <a href="javascript:void(0)"
                                               :id="index===0?'first-group-item':''"
                                               @click="setUsersGroupedCurrentIndex(department.id)"
                                               @mouseup="setUsersGroupedCurrentIndex(department.id)"
                                               class="nav-list-item-link"
                                               :class="{active: department.id == contactsGroupedCurrent.id && usersGroupedCurrentIndex !== 'dismiss', 'can-hover': false, 'current': false }">
                                                <span class="cat-name">{{ department.name }}</span>
                                                <span v-if="tumblers.contactEditable.value  && (userCurrent.access_rights.is_owner || userCurrent.is_can_contact_edit)"
                                                      class="i-wrapper edit-btn" @click="openStaffGroup(department)">
                                                    <span class="i i-pencil2" @click.prevent=""></span>
                                                    <span class="i i-pencil2-active" @click.prevent=""></span>
                                                </span>
                                                <div class="count" v-else>
                                                    {{ department.contacts.length }}
                                                </div>
                                            </a>
                                        </li>
                                    </draggable>

                                    <div class="nav-list-item">
                                        <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex('dismiss')"
                                           class="nav-list-item-link"
                                           :class="{active: usersGroupedCurrentIndex == 'dismiss', 'can-hover': false, 'current': false }">
                                            <span class="cat-name">Не работаем</span>
                                            <div class="count">
                                                {{ dismiss.length }}
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="add-section__wrap" @click="openStaffGroup">
                                    <div class="add-section">
                                        <span class="i i-plus8"></span>
                                        <span class="i i-plus8-active"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                </aside-sticky>

                <div class="container__full container-scroll container__right container__staff" v-if="contactGrouped.length" :style="{minHeight: minHeight + 'px' }">
                    <div class="staff__table-head">
                        <div class="head-item mr8" style="width: 390px;">
                            Пользователь
                        </div>
                        <div class="head-item mr8 text-center" style="width: 254px;">
                            Email
                        </div>
                        <div class="head-item text-right" style="width: 102px">
                            Телефон
                        </div>
                    </div>

                    <div class="workers-list"
                         v-if="contactsGroupedCurrent.contacts.length !== 0 && tumblers.contactEditable.value">
                        <div :id="'user_'+contact.id" class="worker" v-for="contact in contactsGroupedCurrent.contacts"
                             :key="contact.id">
                            <div class="worker-name">
								<div class="name">
									<span class="text-size-m df">{{ contact.keyword }} {{ contact.fio }}
										<tooltip
			                                    :direction="'bottom-center-direction'"
			                                    :add-class-wrap="'comment'"
			                                    :isChangeablePos="false"
												v-if="contact.info"
			                                    :add-style="{width: 300 + 'px'}">
			                                <span slot="tooltipBtn">
			                                    <span class="i i-info4"></span>
			                                </span>

			                                <div slot="tooltipContent">
			                                    <span class="txt">
			                                        {{contact.info}}
			                                    </span>
			                                </div>
			                            </tooltip>
									</span>
	                                <span class="text-color-grey text-size-xs">{{ contact.keywordOther }}</span>
								</div>
                            </div>
                            <div class="worker-email">
                                {{ contact.email }}
                            </div>
                            <div class="worker-phone">
                                {{ contact.phone }}
                            </div>
                            <span v-if="tumblers.contactEditable.value" class="i-wrapper" @click="openAddContact(contact)">
                                <span class="pencil"></span>
                                <span class="pencil-active"></span>
                            </span>
                        </div>
                    </div>
                    <div class="workers-list" v-else-if="contactsGroupedCurrent.contacts.length !== 0">
                        <div :id="'user_'+contact.id" class="worker" v-for="contact in contactsGroupedCurrent.contacts"
                             :key="contact.id">
                            <div class="worker-name">
								<div class="name">
									<span class="text-size-m df">{{ contact.keyword }} {{ contact.fio }}
										<tooltip
			                                    :direction="'bottom-center-direction'"
			                                    :add-class-wrap="'comment'"
			                                    :isChangeablePos="false"
												v-if="contact.info"
			                                    :add-style="{width: 300 + 'px'}">
			                                <span slot="tooltipBtn">
			                                    <span class="i i-info4"></span>
			                                </span>

			                                <div slot="tooltipContent">
			                                    <span class="txt">
			                                        {{contact.info}}
			                                    </span>
			                                </div>
			                            </tooltip>
									</span>
	                                <span class="text-color-grey text-size-xs">{{ contact.keywordOther }}</span>
								</div>
                            </div>
                            <div class="worker-email">
                                {{ contact.email }}
                            </div>
                            <div class="worker-phone">
                                {{ contact.phone }}
                            </div>
                            <div class="user-fired" v-if="!tumblers.contactEditable.value && contact.banned ">
                                <tooltip
                                        :direction="'left-center-direction'"
                                        :isBtnClose="false"
                                        :add-style="{width: 'auto'}">
                                    <span slot="tooltipBtn">
                                        <div class="i i-stop i--dark-trans"></div>
                                    </span>

                                    <div slot="tooltipContent" style="white-space: nowrap">
                                        Пользователь заблокирован
                                    </div>
                                </tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.staffGroup.show" :name="popups.staffGroup.name" :width="400"
               :add-class="'add-cat'">
            <contact-group></contact-group>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="false" :show="popups.removeContactGroupError.show"
               :name="popups.removeContactGroupError.name" :width="400">
            <remove-contact-group-error></remove-contact-group-error>
        </popup>

        <popup :is-set-styled="false" :show="popups.addContact.show" :name="popups.addContact.name" :width="800"
               :add-class="'add-worker'">
            <add-contact :usersGroupedCurrentIndex="usersGroupedCurrentIndex"
                         @change="setUsersGroupedCurrentIndex"></add-contact>
        </popup>

        <popup :is-set-styled="false" :show="popups.dismissContact.show" :name="popups.dismissContact.name"
               :width="430">
            <dismiss-contact></dismiss-contact>
        </popup>

    </div>
</template>


<script>
import {mapState} from 'vuex';
import Popup from '@/components/modal/Popup.vue';
import ContactGroup from '@/components/modal/rules/ContactGroup.vue';
import RemoveContactGroupError from '@/components/modal/rules/RemoveContactGroupError.vue';
import AddContact from '@/components/modal/rules/AddContact.vue';
import Tooltip from '@/components/Tooltip.vue';
import draggable from '@/helpers/vuedraggable.js';
import DismissContact from '@/components/modal/rules/DismissContact.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue';
import Tumbler from '@/components/Tumbler.vue';
import AsideSticky from '@/components/AsideSticky.vue';

export default {
    metaInfo() {
        return {
            title: 'КОНТАКТЫ',
            titleTemplate: this.$store.state.options.titleTemplate
        }
    },
    name: "Contacts",
    components: {
        Popup,
        ContactGroup,
        RemoveContactGroupError,
        Tooltip,
        draggable,
        AddContact,
        DismissContact,
        SubmitBtn,
        Tumbler,
        AsideSticky,
    },
    data: function () {
        return {
            drag: false,
            curDrugGroupIndex: 0,
            btnType: 'normal',
            usersGroupedCurrentIndex: 0,
			minHeight: false,
        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            topSections: state => state.rules.topSectionsStaff,
            tumblers: state => state.rules.tumblers,
            canDrag: state => state.rules.canDrag,
            dismiss: state => state.contacts.dismiss,
            userCurrent: state => state.users.user,
        }),
        contactsGroupedCurrent() {
            let group = {
                users: []
            };
            if (this.usersGroupedCurrentIndex == 'dismiss') {
                group.contacts = this.dismiss;
                group.name = 'Не работаем';
            } else {
                for (let g in this.contactGrouped) {
                    if (!group.id) {
                        group = this.contactGrouped[g]
                    }
                    if (this.contactGrouped[g].id == this.usersGroupedCurrentIndex) {
                        group = this.contactGrouped[g]
                    }
                }
            }

            return group
        },
        contactGrouped: {
            set(value) {
                this.$store.dispatch('contacts/setGroupSort', value);
            },
            get() {
                return this.$store.state.contacts.contacts;
            }
        },
        userTotal() {
            let total = 0;
            for (let g in this.contactGrouped) {
                total += this.contactGrouped[g].contacts.length
            }
            return total;
        }
    },
    methods: {
        up: function (index) {
            this.$store.dispatch('contacts/setMoveGroup', {index: index, direction: 'up'});
        },
        down: function (index) {
            this.$store.dispatch('contacts/setMoveGroup', {index: index, direction: 'down'});
        },
        openStaffGroup: function (group = []) {
            this.$store.commit('contacts/setEditGroup', group);
            this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
        },
        openAddContact: function (contact = []) {
            this.$store.commit('contacts/setEditContact', contact);
            this.$store.dispatch('popups/open', {name: this.popups.addContact.name});
        },
        dragSave: function (index) {
            if (this.drag) {
                let i = false
                for (let g in this.contactGrouped) {
                    if (this.contactGrouped[g].id == index) {
                        i = g
                    }
                }
                if (i !== false) {
                    this.$store.dispatch('contacts/setUserSort', {index: i});
                }

                this.drag = false;
            }
        },
        dragSaveGrouped: function () {
            if (this.drag) {
                this.drag = false;
            }
        },
        dragStart: function (index) {
            this.curDrugGroupIndex = index;
        },
        dragStatus: function (e) {
            this.drag = true;
        },
        setUsersGroupedCurrentIndex(index) {
            if (!this.drag) {
                this.usersGroupedCurrentIndex = index;
            }
        }
    },
	watch: {
		contactGrouped(val){
			if(!this.minHeight){
				this.$nextTick(() => {
					this.minHeight = this.$refs.aside.getBoundingClientRect().height + 50;
				})
			}
		}
	},
    mounted() {
        this.$store.dispatch('contacts/getContacts');
    },
}
</script>
